import Splide from '@splidejs/splide';

const splidePriceItem1 = document.getElementsByClassName('splide splide__price-1');

if (splidePriceItem1.length) {
    for (let i = 0; i < splidePriceItem1.length; i++) {
        let priceSplide = new Splide(splidePriceItem1[i], {
            gap: '24px',
            arrows: false,
            pagination: true,
            omitEnd: true,
            padding: 'calc(50% - 139.5px)',
        }).mount();
    }
}

const SliderScroll = (slug) => {
    // カスタムボタンを追加
    const customButton = document.getElementById('custom-button-' + slug);
    if (customButton) {
        const wrapper = customButton.parentElement;
        let sliderWrap = document.getElementById('slide_wrap' + slug);
        let inner = document.getElementById('slide_list' + slug);
        let innerHeight = inner.clientHeight;

        sliderWrap.style.height = innerHeight + 'px';
        let startX;
        let isDragging = false;

        customButton.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX - customButton.getBoundingClientRect().left;
            e.preventDefault(); // テキスト選択を防ぐ
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
        });

        document.addEventListener('mousemove', (e) => {
            if (isDragging) {
                const wrapperRect = wrapper.getBoundingClientRect();
                const buttonWidth = customButton.offsetWidth;

                let newX = e.clientX - wrapperRect.left - startX;
                const maxX = wrapperRect.width - customButton.offsetWidth - 3; // 3pxの余白
                if (newX < 3) newX = 3; // 左端での余白
                if (newX > maxX) newX = maxX; // 右端での余白
                customButton.style.left = `${newX}px`;
                // 左の余白をパーセンテージで計算
                const leftMarginPercentage = ((newX - 3) / (wrapperRect.width - buttonWidth - 6)) * 100;

                // スライダーを同期的に移動させる
                const sliderWrap = document.getElementById('slide_wrap' + slug);
                const sliderList = document.getElementById('slide_list' + slug);
                const wrapWidth = sliderWrap.offsetWidth;
                const maxSlideWidth = sliderList.scrollWidth;
                const newPosition = (maxSlideWidth - wrapWidth) * (leftMarginPercentage / 100);
                sliderList.style.transform = `translateX(${-newPosition}px)`;
            }
        });
    }
}

SliderScroll('1');
SliderScroll('2');
SliderScroll('3');
SliderScroll('4');
SliderScroll('5');



const eventCards = document.getElementsByClassName('splide js-splide-card');
if (eventCards.length) {
    for (let i = 0; i < eventCards.length; i++) {
        let eventCardsSplide = new Splide(eventCards[i], {
            type: 'loop',
            rewind: true,
            gap: '24px',
            arrows: false,
            pagination: true,
            autoplay: true,
            speed: 800,
            interval: 8000,
            breakpoints: {
                1025: {

                }
            }
        }).mount();
    }
}